import { UPDATE_NOTIFICATION_COUNT } from "../../utils/constants";

export const updateNotificationCount = (fluctuate) => ({
  type: UPDATE_NOTIFICATION_COUNT,
  payload: fluctuate,
});
